import React from 'react'
import { startCase } from 'lodash-es'
import Box from '@node-space/storybook-components/dist/Box'
import { Text } from '@node-space/storybook-components/dist/Text'
import TextList from '@node-space/storybook-components/dist/TextList'
import { sentenceCase } from 'utils/utils'

interface ErrorItemProps {
  subTitle: string
  errors: string[]
  displaySubTitle: boolean
}

export const ErrorItem = ({ subTitle, errors, displaySubTitle }: ErrorItemProps) => (
  <Box key={subTitle} paddingB={12}>
    {displaySubTitle && (
      <Box paddingB={4}>
        <Text color="inherit" size="sm" weight="medium">
          {sentenceCase(startCase(subTitle))}
        </Text>
      </Box>
    )}
    <TextList
      textSize="xs"
      textColor="inherit"
      listStyle="bullet"
      listItems={errors?.map((error, index) => ({
        key: `${subTitle}-${index}`,
        children: error,
      }))}
      className="pl-3"
    />
  </Box>
)
